<!-- 评价导师 -->
<template>
  <div class="feedback-evaluate"
       id="components-feedback-evaluate">
    <div>
      <h1>评价导师</h1>
      <ul class="base-info">
        <li>辅导开始时间：{{appDetail.menteeResultTimeStr}} （{{appDetail.menteeZone | zoneTitleMap}}）</li>
        <li>
          <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
          <span v-else>{{appDetail.module | appModuleTitleMap }}</span>
        </li>
        <li>{{appDetail.mentorType}}导师 - {{appDetail.mentorName}}</li>
      </ul>
      <Form ref="formValidate"
            :model="formValidate"
            :rules="ruleValidate"
            label-position="top">
        <FormItem label="导师是否按时出现？"
                  prop="scheduleStatus">
          <Select v-model="formValidate.scheduleStatus"
                  placeholder="请选择"
                  style="width:520px;"
                  @on-change="changeCheduleStatus">
            <Option v-for="(item,index) in studentFeedbackPunctual"
                    :key="index"
                    :value="item.value">{{item.title}}</Option>
          </Select>
        </FormItem>
        <template v-if="formValidate.scheduleStatus !== 'NOT_APPEAR'">
          <FormItem label="您认为导师专业度为何？"
                    prop="professionalismGraded">
            <Evaluation v-model="formValidate.professionalismGraded"
                        :label="studentEvaluation1"></Evaluation>
          </FormItem>
          <FormItem label="您认为导师态度如何？"
                    prop="attitudeGraded">
            <Evaluation v-model="formValidate.attitudeGraded"
                        :label="studentEvaluation2"></Evaluation>
          </FormItem>
          <FormItem :label="appDetail.videoType === 'TENCENT'? '内置视频连线质量？': 'Zoom视频连线质量？' "
                    prop="videoGraded">
            <Evaluation v-model="formValidate.videoGraded"
                        :label="studentEvaluation3"></Evaluation>
          </FormItem>
        </template>
        <FormItem label="你觉得这个Module对你有帮助吗？"
                  prop="moduleHelpfulGraded"
                  v-if="!remainTime.remainTime || remainTime.remainTime<=0">
          <Evaluation v-model="formValidate.moduleHelpfulGraded"
                      :label="studentEvaluation4"></Evaluation>
        </FormItem>
        <FormItem :label="ruleValidate.content? 'Please add your description or screenshot': ''"
                  prop="content"
                  :show-message="!!ruleValidate.content">
          <div class="feedback-evaluate-editor">
            <editor ref="analysisEditor"
                    :cache=false
                    v-model="formValidate.content" />
          </div>
        </FormItem>
      </Form>

      <div class="feedback-evaluate-btn">
        <div style="display:inline-block;"
             v-if="!$slots.default">
          <Button class="btn"
                  :loading="isSub"
                  @click="handleEvaluate">评价导师</Button>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { subEvaluateAppointment } from '@/api/evaluate'
import { studentFeedbackPunctual, studentEvaluation1, studentEvaluation2, studentEvaluation3, studentEvaluation4 } from '@/constant'
import { getAppRemainTime } from '@/api/appointment'
// components
import Editor from '_c/editor/editor'
import Evaluation from '_c/mentor/evaluation'
export default {
  name: 'app-project-evaluate-mentor',
  props: {
    appDetail: {
      type: Object,
      default () {
        return {}
      }
    },
    isPackageId: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Editor,
    Evaluation
  },
  data () {
    return {
      studentFeedbackPunctual,
      studentEvaluation1,
      studentEvaluation2,
      studentEvaluation3,
      studentEvaluation4,
      isSub: false,
      formValidate: {
        professionalismGraded: undefined,
        attitudeGraded: undefined,
        videoGraded: undefined,
        moduleHelpfulGraded: undefined,
        dissatisfiyReason: undefined,
        content: ''
      },
      ruleValidate: {
        scheduleStatus: [{ required: true, message: '请选择导师是否按时出现' }],
        professionalismGraded: [{ required: true, message: '请选择星级' }],
        attitudeGraded: [{ required: true, message: '请选择星级' }],
        videoGraded: [{ required: true, message: '请选择星级' }],
        moduleHelpfulGraded: [{ required: true, message: '请选择星级' }],
        content: ''
      },
      remainTime: {}
    }
  },
  computed: {},
  mounted () {
    this.getAppRemainTime()
  },
  methods: {
    handleEvaluate () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.formValidate)
          params.appId = this.appDetail.id
          this.isSub = true
          subEvaluateAppointment(params).then(() => {
            this.$zlr_message('评价成功', 'success')
            this.$emit('on-success')
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        }
      })
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs['formValidate'].validate((valid) => {
          if (valid) {
            resolve({ ...this.formValidate })
          } else {
            resolve(false)
          }
        })
      })
    },
    // 评价状态
    changeCheduleStatus (data) {
      if (data === 'NOT_APPEAR') {
        Object.assign(this.formValidate, {
          professionalismGraded: undefined,
          attitudeGraded: undefined,
          videoGraded: undefined
        })
      }
    },
    getAppRemainTime () {
      this.remainTime = {}
      let appDetail = this.appDetail
      if (!this.appDetail || !this.appDetail.id) return false
      getAppRemainTime({
        'jointId': appDetail.jointId,
        'module': appDetail.module,
        'appointmentType': appDetail.type
      }).then(res => {
        this.remainTime = res.data.model
      })
    }
  },
  watch: {
    formValidate: {
      deep: true,
      handler (newValue) {
        let ketAll = ['professionalismGraded', 'attitudeGraded', 'videoGraded', 'moduleHelpfulGraded']
        let isRequiredContent = false
        for (let i of ketAll) {
          if (typeof newValue[i] === 'number' && newValue[i] < 3) {
            isRequiredContent = true
            break
          }
        }
        if (isRequiredContent) {
          this.$set(this.ruleValidate, 'content', [{ required: true, message: '请填写内容' }])
        } else {
          this.$set(this.ruleValidate, 'content', '')
        }
      }
    },
    appDetail: {
      deep: true,
      handler () {
        this.getAppRemainTime()
      }
    }
  }
}
</script>
<style lang='less' scoped>
.feedback-evaluate {
  > div {
    > h1 {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 30px;
      font-weight: normal;
      margin-bottom: 24px;
    }
  }
  .base-info {
    margin-bottom: 40px;
    li {
      height: 24px;
      line-height: 24px;
      margin-bottom: 4px;
    }
  }
  &-editor {
    margin-bottom: 20px;
    width: 800px;
  }
  &-btn {
    margin-top: 40px;
  }
  .btn {
    padding: 3px 15px;
    font-size: 12px;
    border-radius: 2px;
    border: none;
    width: 96px;
    color: #ffffff;
    line-height: 24px;
    background: linear-gradient(-132deg, #69c0ff 0%, #87e8de 100%);
  }
}
</style>
<style lang="less">
#components-feedback-evaluate {
  .ivu-form-item {
    margin-bottom: 32px;
  }
  .ivu-form-item-label {
    &:before {
      display: none;
    }
  }
  .w-e-text-container {
    height: 130px !important;
  }
}
</style>
